var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.5,28.7H9.6c-0.8,0-1.5-0.7-1.5-1.5V4.6c0-0.8,0.7-1.5,1.5-1.5h33.9c0.5,0,1,0.3,1.3,0.7c0.3,0.4,0.3,1,0.1,1.5 l-5.5,10.6l5.5,10.6c0.2,0.5,0.2,1-0.1,1.5C44.5,28.4,44,28.7,43.5,28.7z M11.1,25.7H41l-4.7-9.1c-0.2-0.4-0.2-0.9,0-1.4L41,6.1 H11.1V25.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,48.5c-0.8,0-1.5-0.7-1.5-1.5V4.6c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5V47C11.1,47.8,10.5,48.5,9.6,48.5z"
  }))));
}

export default SvgFlag;